import request from '../request'
import { objectToQueryString } from '../../components/Dashboard/DataEntry/helpers/objectToQueryString'

export const getDashboardStudent = (userId, filter) =>
  request.post(`/dashboard/student/${userId}`, filter).then((res) => res)

export const getClassesOverview = (userId, classId) =>
  request.get(`/dashboard/teacher/${userId}/classes-overview/${classId}`).then((res) => res)
